<template>
  <v-container
    id="developerView"
    tag="section"
  >
    <!-- <v-row>
      <v-col>
        <log-view :user="$store.state.user" />
      </v-col>
    </v-row> -->
    <v-row>
      <v-col>
        <api-caller />
      </v-col>
    </v-row>
</v-container>
</template>

<script>
  import 'firebase/auth'
  // import Logs from './Logs.vue'
  import apiCaller from './ApiCaller'

  export default {
    name: 'Developer',

    components: {
      // 'log-view': Logs,
      'api-caller': apiCaller,
    },

    data: () => ({
      loading: true,
    }),

    computed: {
      activityTitle () {
        return this.classLearner ? `${this.classLearner.user.displayName}'s activity` : 'Loading'
      },
      userID () {
        return this.$store.state.user ? this.$store.getters.currentUserProfile.user.id : undefined
      },
      userFirstName () {
        return this.$store.state.user ? this.$store.getters.currentUserProfile.user.displayName.split(' ')[0] : ''
      },
      userIsLearner () {
        return this.$store.state.user ? this.$store.getters.currentUserProfile.user.roles.includes('learner') : false
      },
    },

    async mounted () {
      this.loading = true
      this.loading = false
    },

    methods: {
    },

  }
</script>

<style>
</style>
